export default function(email) {
  const re = /^\S+@\S+$/;
  return re.test(String(email).toLowerCase());
}
